import { useServiceProps, dialogService } from "ftl-core";
import React from "react";
import FTLDialog from "../components/other/FTLDialog";
export default ({ style, service = dialogService, disabledControls, }) => {
    const [props] = useServiceProps(service);
    return (React.createElement(FTLDialog, Object.assign({ disabledControls: disabledControls, style: style, onCancel: (e) => {
            (props === null || props === void 0 ? void 0 : props.onCancel) && props.onCancel(e);
            service.close();
        }, onClose: (...args) => {
            (props === null || props === void 0 ? void 0 : props.onClose) && props.onClose(...args);
            service.close();
        } }, props)));
};
//# sourceMappingURL=DialogContainer.js.map